<template>
    <div :class="[`backdrop ${isDeleteAllBlock ? 'show-backdrop' : ''}`]" @click="$emit('on-backdrop-click')">
        <div :class="[`main-success-modal-block ${isDeleteAllBlock && isDeleted ? 'open-payment-info-block' : ''}`]">
            <div class="success-icon-block">
                <check-icon class="success-icon" />
            </div>
            <p class="success-title">{{ $t('homePage.deleteAllSuccess') }}</p>
            <button @click="$emit('on-backdrop-click')" class="success-button">{{ $t('homePage.okay') }}</button>
        </div>
        <div :class="[`main-success-modal-block ${isDeleteAllBlock && !isDeleted ? 'open-payment-info-block' : ''}`]">
            <p class="success-title">{{ $t('homePage.deleteAllTitle') }}</p>
            <p class="success-text">{{ $t('homePage.deleteAllText') }}</p>
            <input v-model="data" type="text" class="delete-test-word-input"
                @click.stop="">
            <div>
                <button v-if="isCanAllDelete" @click.stop="deleteAllOperations()" class="success-button delete">{{
                    $t('homePage.deleteAllButton') }}</button>
                <button v-else @click.stop="" class="success-button delete-null">{{
                    $t('homePage.deleteAllButton') }}</button>
                <button @click.stop="$emit('on-backdrop-click')" class="success-button">{{
                    $t('homePage.deleteAllCancel') }}</button>
            </div>
        </div>
    </div>
</template>

<script>

import langObject from '../../libs/i18n/index'

import {
    CheckIcon
} from 'vue-feather-icons';

export default {
    name: "Success-block",
    components: {
        CheckIcon
    },
    props: {
        isDeleteAllBlock: {
            type: Boolean,
            require: true
        },
    },
    data() {
        return {
            data: '',
            isCanAllDelete: false,
            isDeleted: false
        }
    },
    async mounted() {

    },

    methods: {
        deleteAllOperations() {
            setTimeout(() => {
                this.isDeleted = true
            }, 2000)
        }
    },
    computed: {

    },
    watch: {
        data(newVal, oldVal) {
            let val = oldVal
            val 
            let currLang = langObject.locale
            let keyWord
            if (currLang === 'en') {
                keyWord = 'clear'
            } else if (currLang === 'uk') {
                keyWord = 'очистити'
            } else if (currLang === 'ru') {
                keyWord = 'очистить'
            } else if (currLang === 'es') {
                keyWord = 'limpiar'
            }
            if (newVal.toLowerCase() === keyWord) {
                this.isCanAllDelete = true
            } else {
                this.isCanAllDelete = false
            }
        }
    }
}
</script>

<style scoped>
.main-success-modal-block {
    position: absolute;
    width: 70%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    opacity: 0;
    pointer-events: all !important;
    -webkit-backdrop-filter: saturate(180%) blur(80px);
    backdrop-filter: saturate(180%) blur(80px);
    background-color: rgba(255, 255, 255, 0.8);
    pointer-events: none;
    z-index: 0 !important;
    border: 0px !important;
    border-radius: 20px;
    transition: all .5s ease;
}

.open-payment-info-block {
    opacity: 1;
    z-index: 9999 !important;
}

.success-icon-block {
    margin: 0 auto;
    width: 50px;
    height: 50px;
    background: var(--secondary-bg-color);
    border-radius: 50%;
    display: flex;
}

.success-icon {
    color: #fff;
    width: 40px;
    height: 40px;
    margin: auto;
}

.success-title {
    color: #1b1b1b;
    font-family: "Source Sans 3", sans-serif;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: -0.6px;
    font-size: 19px;
    text-align: center;
    margin-top: 20px;
}

.success-text {
    text-align: center;
    color: #393939;
    font-family: "Source Sans 3", sans-serif;
    line-height: 20px;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0px;
    margin-top: 5px;
}

.success-button {
    position: relative;
    font-family: "Source Sans 3", sans-serif;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 12px;
    font-size: 13px;
    padding: 14px 20px;
    width: 100%;
    color: #FFF;
    font-size: 12px;
    margin-top: 10px;
    padding: 12px 18px;
    border: none;
    box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
    transition: all 120ms ease;
    background-image: var(--main-bg-color);
    cursor: pointer;
}

.success-button.delete {
    background: #d84558;
    margin-top: 20px;
}

.success-button.delete-null {
    background: #f59da9;
    margin-top: 20px;
    cursor: not-allowed;
}

.success-button::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: inherit;
    z-index: -1;
    transform: scale(0.75) translateY(5px) translateZ(0px);
    filter: blur(8px);
}

.delete-test-word-input {
    display: flex;
    width: 100%;
    margin: 10px auto 0 auto;
    padding: 11px 10px;
    border: 1px rgba(0, 0, 0, 0.15) solid !important;
    border-radius: 10px;
    background: #e8e8e8;
    height: 53px;
    outline: none;
    font-weight: 400;
    line-height: 1.5;
    font-size: 12px;
    font-family: "Source Sans 3", sans-serif;
    color: #212529;
}
.delete-test-word-input::placeholder {
    color: #b8babc;
}
</style>